// removed by extract-text-webpack-plugin
module.exports = {"supplier-database-page":"supplier-database-page","nf-social-links":"nf-social-links","video-thumbnail-card":"video-thumbnail-card","video-thumbnail":"video-thumbnail","play-button":"play-button","video-info":"video-info","page-title":"page-title","content-container":"content-container","content-box":"content-box","lead":"lead"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/static/SupplierDatabase/SupplierDatabase.scss
// module id = 4475
// module chunks = 1